/**
 * Fusion Manage Frontend Constants
 * Centralized constants for API endpoints, feature flags, and frontend-specific values
 * Workspace IDs are read from a JSON config file generated at build time from root .env
 * 
 * Note: The config file is generated by scripts/sync-react-env.js which reads from
 * the root .env file. This is necessary because Create React App can only read
 * .env files in the react-ui directory, but we want to use the same variable names
 * as the backend from the root .env file.
 */

// Import workspace IDs from generated config file
// This file is auto-generated at build time from root .env
let workspaceConfig = {};
try {
  workspaceConfig = require('../../config/fusionManageWorkspaces.json');
} catch (e) {
  // Fallback to default values if config file doesn't exist (e.g., first build)
  workspaceConfig = {};
}

// Helper function to get workspace ID from config with fallback
const getWorkspaceId = (configKey, defaultValue) => {
  return workspaceConfig[configKey] || defaultValue;
};

// Feature Flags
export const ENABLE_EPICOR_SUBMISSION = false; // Set to true to enable Epicor + Fusion Manage submission

// API Endpoints
export const API_ENDPOINTS = {
  NCR: '/api/fm/ncr',
  IPI: '/api/fm/ipi',
  CUSTOMER_COMPLAINT: '/api/fm/customer-complaint',
  GRAPHQL: '/api/graphql',
  LOCATIONS_PARSED: '/api/fm/locations/parsed',
  DEPARTMENTS: '/api/fm/departments'
};

// Workspace IDs (for API calls) - read from config file (generated from root .env) with fallbacks
export const WORKSPACE_IDS = {
  NCR: getWorkspaceId('FUSION_MANAGE_WORKSPACE_ID', '98'),
  IPI: getWorkspaceId('FUSION_MANAGE_IPI_WORKSPACE_ID', '374'),
  CUSTOMER_COMPLAINT: getWorkspaceId('FUSION_MANAGE_CUSTOMER_COMPLAINT_WORKSPACE_ID', '736'),
  LOCATIONS: getWorkspaceId('FUSION_MANAGE_LOCATIONS_WORKSPACE_ID', '506'),
  SUPPLIERS: getWorkspaceId('FUSION_MANAGE_SUPPLIERS_WORKSPACE_ID', '14')
};

// View IDs
export const VIEW_IDS = {
  DEFAULT: '1'
};

// Form Types
export const FORM_TYPES = {
  NCR: 'NCR',
  IPI: 'IPI',
  CUSTOMER_COMPLAINT: 'CustomerComplaint'
};

// GraphQL Configuration
export const GRAPHQL_CONFIG = {
  EFX_LIBRARY_IDS: {
    NCR: 'NCR'
  },
  EFX_FUNCTION_IDS: {
    CREATE_NCR: 'create-new-ncr',
    CREATE_IPI: 'create-new-ipi',
    CREATE_CUSTOMER_COMPLAINT: 'create-customer-complaint'
  }
};

